export default __webpack_public_path__ + "b279edf390b0b0bbec1ccb050537a227.png";